"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteUserHandler = exports.addUserImageHandler = exports.editUserHandler = exports.getUserDetailsHandler = void 0;
const account_1 = require("../http/account");
const store_1 = require("../store/redux/store");
const account_2 = require("../store/redux/account");
const authStorage_1 = require("../services/authStorage");
const axios_1 = __importDefault(require("axios"));
const getUserDetailsHandler = () => {
    (0, account_1.getUserDetails)().then(response => {
        store_1.store.dispatch((0, account_2.setUserDetailsAction)(response));
    }).catch(error => {
        console.log(error);
    });
};
exports.getUserDetailsHandler = getUserDetailsHandler;
const editUserHandler = (data) => {
    (0, account_1.editUser)(data).then(response => {
        store_1.store.dispatch((0, account_2.setUserDetailsAction)(response));
    }).catch(error => {
        console.log(error);
    });
};
exports.editUserHandler = editUserHandler;
const addUserImageHandler = (file) => {
    (0, account_1.generatePresignedAvatarUrl)().then(response => {
        const { presigned_url } = response;
        axios_1.default.put(presigned_url, file, {
            headers: {
                'Content-Type': 'image/jpeg',
                'Content-Encoding': 'base64'
            }
        }).then(() => {
            (0, account_1.resizeAndDecodeAvatar)().then(response => {
                store_1.store.dispatch((0, account_2.setUserDetailsAction)(response));
            }).catch(error => {
                console.log('Resize and decode error: ', error);
            });
        }).catch(error => {
            console.log('AWS upload error: ', error);
        });
    }).catch(error => {
        console.log('Generate presigned URL error: ', error);
    });
};
exports.addUserImageHandler = addUserImageHandler;
const deleteUserHandler = (password, callback) => {
    (0, account_1.removeAccount)({ password }).then(() => {
        store_1.store.dispatch((0, account_2.logoutAction)());
        (0, authStorage_1.clearAuthItems)();
        callback();
    }).catch(error => {
        if (error.detail === 'password_incorrect') {
            store_1.store.dispatch((0, account_2.setAccountError)(error.detail));
            callback();
        }
        throw error;
    });
};
exports.deleteUserHandler = deleteUserHandler;
